module.exports = {"server":"http://127.0.0.1:8080/werner-backend-local","deployment":"werner-local","category":"/category","technology":"/technology","digitaloffer":"/digitaloffer","bma":"/bma","tender":"/tender","project":"/project","company":"/company","businessmodel":"/businessmodel","businessmodelbrick":"/businessmodel/brick","bmaelement":"/bmaelement","feedback":"/feedback","notification":"/notification","event":"/event","question":"/question","user":"/userconfiguration","recommend":"/recommend","kitrainer":"/kitrainer","kirc":"/kirc","mainemphases":"/main_emphasis","industrysector":"/industry_sector"}


//////////////////
// WEBPACK FOOTER
// ./config/local.json
// module id = mH2u
// module chunks = 1